import { Component, Input, OnInit } from '@angular/core';

interface OrderStatus {
  orderType: string;
  orderStatus: boolean;
  orderDescription?: string;
}

interface Step {
  orderType: string;
  icon: string;
}

@Component({
    selector: 'order-tracker',
    templateUrl: './order-tracker.component.html',
    styleUrls: ['./order-tracker.component.scss'],
    standalone: false
})
export class OrderTrackerComponent implements OnInit {
  @Input() orderDataDetials: OrderStatus[] = [];
  @Input() currentStatus: string = '';

  steps: Step[] = [
    { orderType: 'Order Received', icon: 'fa fa-check' },
    { orderType: 'Processing', icon: 'fa fa-cog' },
    { orderType: 'Picked by courier', icon: 'fa fa-user' },
    { orderType: 'Delivery on the way', icon: 'fa fa-truck' },
    { orderType: 'Delivered', icon: 'fa fa-check-square-o' }
  ];

  ngOnInit(): void {
    console.log('Order Data Details:', this.orderDataDetials);
    console.log('Current Status:', this.currentStatus);
  }

  isStepActive(index: number): boolean {
    if (!this.currentStatus || !this.steps.length) return index === 0;

    const statusMap: { [key: string]: string } = {
      PENDING: 'Processing',
      Confirmed: 'Order Received',
      Packaged: 'Picked by courier',
      Shipped: 'Delivery on the way',
      DELIVERED: 'Delivered'
    };

    const currentStep = statusMap[this.currentStatus.toUpperCase()] || this.currentStatus;
    const currentIndex = this.steps.findIndex(step => step.orderType === currentStep);

    return currentIndex >= 0 && index <= currentIndex;
  }
}